























































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    componentDataType
} from "../types";
import {
    pageDataType
} from "../types";
import DoughnutChart from "@/components/DoughnutChart.vue";

@Component({
    name: "GlobalFootWearIndystry",
    components: {
        DoughnutChart
    }
})
export default class GlobalFootWearIndystry extends Vue {
    @Prop() public compData!: any | null;
    data() {
        return {
            showChart: false
        }
    }
    handleScroll(event: any) {
        window.pageYOffset > 0 ? (this as any).showChart = true : (this as any).showChart = false;
    }

    created() {
        window.addEventListener('scroll', this.handleScroll);
    }
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
